import { Injectable } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { ResultPopupComponent } from '../../result-popup/result-popup.component';
import { MapService, MapElement } from 'src/app/shared/components/map/map.service';

@Injectable({
  providedIn: 'root'
})
export class ResultMapPopupService {

  mapbox: mapboxgl.Map;

  constructor(
    private windowService: WindowService,
    private mapService: MapService
  ) { }

  listen(mapbox: mapboxgl.Map, layers: string[]) {
    this.mapbox = mapbox;

    layers.forEach(layerName => {
      this.hover(layerName);
      this.click(layerName);
    });
  }

  private hover(layerName: string) {
    this.mapbox.on('mouseenter', layerName, (e) => {
      this.mapbox.getCanvas().style.cursor = 'pointer';
    });

    this.mapbox.on('mouseleave', layerName, (e) => {
      this.mapbox.getCanvas().style.cursor = '';
    });
  }

  private click(layerName: string) {
    this.mapbox.on('click', layerName, (e) => {
      if (!e.defaultPrevented) {
        this.action(e);
        e.preventDefault();
        e.originalEvent.preventDefault();
      }
    });
  }

  private action(e: any) {
    const top = e.originalEvent.clientY;
    const left = e.originalEvent.clientX;
    const feature = e.features[0] as mapboxgl.MapboxGeoJSONFeature;
    const data = feature.properties;
    const componentType = ResultPopupComponent;
    const title = data.title;
    const id = title;
    const lng = e.lngLat.lng;
    const lat = e.lngLat.lat;
    const element: MapElement = { id, lng, lat };

    this.mapService.highlight$.next(element);

    this.windowService.open({
      componentType,
      title,
      config: { data, id },
      position: { top, left }
    })
      .subscribe(() => this.mapService.removeHighlight$.next(element));
  }
}
